export const blockIconsAudioandvideoPlayArrow = (
	<span className='material-symbols-outlined'>play_arrow</span>
);
